"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = require("styled-components");

const elevation = level => (0, _styledComponents.css)(["box-shadow:", ";"], props => props.theme.elevations[level]);

var _default = elevation;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJlbGV2YXRpb24iLCJsZXZlbCIsImNzcyIsInByb3BzIiwidGhlbWUiLCJlbGV2YXRpb25zIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3RoZW1lL2VsZXZhdGlvbi9lbGV2YXRpb24udHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnc3R5bGVkLWNvbXBvbmVudHMnXG5cbmNvbnN0IGVsZXZhdGlvbiA9IChsZXZlbDogbnVtYmVyKSA9PiBjc3NgXG4gIGJveC1zaGFkb3c6ICR7cHJvcHMgPT4gcHJvcHMudGhlbWUuZWxldmF0aW9uc1tsZXZlbF19O1xuYFxuXG5leHBvcnQgZGVmYXVsdCBlbGV2YXRpb25cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUVBLE1BQU1BLFNBQVMsR0FBSUMsS0FBRCxRQUFtQkMscUJBQW5CLHdCQUNGQyxLQUFLLElBQUlBLEtBQUssQ0FBQ0MsS0FBTixDQUFZQyxVQUFaLENBQXVCSixLQUF2QixDQURQLENBQWxCOztlQUllRCxTIn0=